export default __webpack_public_path__ + "static/media/notFoundBg.7e1ca706.jpg";